
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[cid]",
      function () {
        return require("private-next-pages/[cid]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[cid]"])
      });
    }
  